import React from 'react'
import { useState } from "react"
import { Col } from 'reactstrap'
import * as toastr from "toastr"

import * as yconnect_logo from "Placements/Assets/img/yconnect-logo-purple.png"

import Loader from "Placements/Components/Loader"
import API from "Placements/API"
import { userDataLayer } from 'Placements/Utils/DataLayer'

type LoginPageProps = {
    onLogin: Function
}

const Formulario = ({ onLogin }: LoginPageProps) => {

    const [userName, setUserName] = useState("")
    const [password, setPassword] = useState("")
    const [isLoading, setLoading] = useState(false)
    const [yconnectOption, setYconnectOption] = useState(false);

    const handleLogin = async (e: any) => {
        e.preventDefault();
        setLoading(true)

        let response: any = null;

        try {

            response = yconnectOption ? await API.Auth.YconnectLogin({ UserName: userName, Senha: password }) 
                                      : await API.Auth.Post({ email: userName, senha: password });
            
        } catch (error) {

            if (error.response && error.response.status == 401) {
                toastr.error("Email e/ou senha inválidos.", "")
            } else {
                toastr.error(error.message, "Error")
                return
            }
            
        } finally {
            setLoading(false)
        }

        if (response == null) {
            return
        }

        const { data } = response

        if (data && data.sucessoNoLogin && data.token) {
            const authToken = data.token

            const newUserData = {
                ...data,
                nome: data.usuario.Nome,
            }
            localStorage.setItem("AuthorizationPl", authToken)
            localStorage.setItem("dataPl", JSON.stringify(newUserData))
            userDataLayer.SigninClick(data.usuario.Id_Usuario)
            onLogin(newUserData)
        } else if (data && data.isBlocked) {
            toastr.warning("Contact your school manager", "Blocked user!")
        } else if (data && data.emailConfirmado === false) {
            toastr.warning("Please check your email to confirm", "Email not confirmed!")
        } else {
            toastr.warning("Username or password incorrect", "Authentication error!")
        }
    }

    const handleYConnectOption = () => {

        if(yconnectOption){

            toastr.info("Opção de login YConnect desativada");
            setYconnectOption(false);

        } else {

            toastr.info("Opção de login YConnect ativada");
            setYconnectOption(true);

        }

    }

    return (
        <Col md={12} className="form-login">
            {isLoading && <Loader />}
            <div>
                <h3 className="form-title">Bem-vindo, cidadão do mundo!</h3>
                <p className="form-txt">Faça o teste online e descubra o seu nível de inglês e/ou espanhol.</p>

                <form onSubmit={handleLogin} >
                    <a href="#/register-user" className="form-btn btn">Quero me cadastrar</a>
                    <hr />
                    <p className="form-txt">Ou você já tem cadastro?</p>
                    {
                    yconnectOption 
                        ? <input
                            id="username"
                            name="username"
                            type="text"
                            className="form-input"
                            placeholder="Qual é o seu usuário no YConnect?"
                            onChange={(e: any) => setUserName(e.target.value)}
                            autoComplete="on"
                        />
                        : <input
                            id="username"
                            name="username"
                            type="email"
                            className="form-input"
                            placeholder="Qual é seu email?"
                            onChange={(e: any) => setUserName(e.target.value)}
                            autoComplete="on"/>
                    }
                    <input
                        id="password"
                        name="password"
                        type="password"
                        className="form-input"
                        placeholder="E sua senha?"
                        onChange={(e: any) => setPassword(e.target.value)}
                        autoComplete="on"
                    />
                    <div className="custom-control custom-switch">
                        <input type="checkbox" className="custom-control-input" id="customSwitch1" onChange={handleYConnectOption}/>
                        <label className="custom-control-label" htmlFor="customSwitch1"></label>
                        <img src={yconnect_logo} alt="Opção de Login YConnect" title="Opção de Login YConnect" className="yconnect-logo"/>
                    </div>
                    <p className="form-txt-fp"><a href="#/forgot-password">Ops, esqueci minha senha</a></p>
                    <input
                        type="submit"
                        className="submit-btn btn"
                        value="Continuar"
                        disabled={!userName || !password}
                    />
                </form>
            </div>
        </Col>
    )
}

export default Formulario
